// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Alarm service. Query-shaped like the other services (see planService.ts) so
// screens and hooks stay unchanged when the backend alarms endpoint lands.
//
// The backend will serve (mocked, then real) alarms soon; until then these are
// stubs that resolve empty so the alarm surfaces render clean empty states.
// Wiring the backend later means editing only this file.

import type { Alarm, AlarmBucket, AlarmQuery } from '../types/alarm';

export async function getAlarms(_query: AlarmQuery = {}): Promise<Alarm[]> {
  // TODO: wire to backend alarms endpoint once available.
  return [];
}

export async function getAlarmById(_id: string): Promise<Alarm | null> {
  // TODO: wire to backend alarms endpoint once available.
  return null;
}

/** Distinct group labels available for the Home group filter (for a site). */
export async function getAlarmGroups(_siteId?: string): Promise<string[]> {
  // TODO: wire to backend alarms endpoint once available.
  return [];
}

/** Per-bucket counts for the subnav pills (scoped to a site when provided). */
export async function getBucketCounts(_siteId?: string): Promise<Record<AlarmBucket, number>> {
  // TODO: wire to backend alarms endpoint once available.
  return { critical: 0, high: 0, events: 0, closed: 0 };
}

export async function acknowledgeAlarm(_id: string): Promise<Alarm | null> {
  // TODO: wire to backend alarms endpoint once available.
  return null;
}

export async function closeAlarm(_id: string, _outcome: string): Promise<Alarm | null> {
  // TODO: wire to backend alarms endpoint once available.
  return null;
}
